"use strict";
export { CollapsibleContent as Content, CollapsibleContext as Context, CollapsiblePropsProvider as PropsProvider, CollapsibleRoot as Root, CollapsibleRootProvider as RootProvider, CollapsibleTrigger as Trigger } from './collapsible.js';
